/* global mixpanel */

import {Component} from 'panel';
import {registerMPElement} from 'common/util/register-element';
import {smartHubApi} from 'common/widgets/alerts/dropdown/api';

import css from './index.styl?inline';
import template from './index.jade';

export default registerMPElement(
  `mp-smart-hub-global`,
  class extends Component {
    get config() {
      return {
        css,
        template,
        useShadowDom: true,
        defaultState: {
          open: false,
          unreadCount: 0,
        },
        refreshInterval: 60 * 60 * 1000,
        helpers: {
          handleClickDropdown: () => {
            this.update({
              open: !this.state.open,
            });
            mixpanel.p3new.track(`Click Navigation`, {'Tab Group': `Notifications`});
          },
          handleDropMenuChange: (ev) => {
            ev.stopPropagation();
            this.dispatchEvent(
              new CustomEvent(`change`, {
                detail: ev.detail,
              }),
            );

            const state = ev.detail.state;
            if (![`open`, `closed`].includes(state)) {
              return;
            }
            const open = ev.detail.state === `open`;
            this.update({open});
          },
          handleManageAlerts: (ev) => {
            ev.stopPropagation();
            if (!ev.detail.modifierKey) {
              this.update({open: false});
            }
          },
          handleClickedLink: (ev) => {
            ev.stopPropagation();
            if (!ev.detail.modifierKey) {
              this.update({open: false});
            }
          },
          // if report id is specified, only alerts on a particular report are marked as read
          handleAlertsMarkedAsRead: (ev) =>
            ev.detail.reportId ? this.fetchUnreadCount() : this.update({unreadCount: 0}),
        },
      };
    }

    connectedCallback() {
      super.connectedCallback(...arguments);

      this.fetchUnreadCount();

      this._boundFetch = () => this.fetchUnreadCount();
      this._boundUnschedule = () => this.unscheduleNextFetch();
      window.addEventListener(`focus`, this._boundFetch);
      window.addEventListener(`blur`, this._boundUnschedule);
    }

    static get observedAttributes() {
      return Component.observedAttributes.concat([`is-old-chrome`, `open`, `project-id`, `utc-offset`, `workspace-id`]);
    }
    attributeChangedCallback(attr) {
      super.attributeChangedCallback(...arguments);
      if (attr === `open` && this.initialized) {
        this.update({open: this.isAttributeEnabled(`open`)});
      }
    }

    disconnectedCallback() {
      super.disconnectedCallback(...arguments);
      this.unscheduleNextFetch();

      window.removeEventListener(`focus`, this._boundFetch);
      window.removeEventListener(`blur`, this._boundUnschedule);
    }

    unscheduleNextFetch() {
      if (this._pendingFetchId) {
        clearTimeout(this._pendingFetchId);
        delete this._pendingFetchId;
      }
    }

    _scheduleNextFetch() {
      this._pendingFetchId = setTimeout(() => {
        delete this._pendingFetchId;
        this.fetchUnreadCount();
      }, this.config.refreshInterval);
    }

    fetchUnreadCount() {
      smartHubApi({projectId: this.getAttribute(`project-id`), workspaceId: this.getAttribute(`workspace-id`)})
        .fetchUnreadCount()
        .then((results) => {
          if (!this.state.open) {
            this.update({unreadCount: results});
          }
          this._scheduleNextFetch();
        });
    }
  },
);
